import { render, staticRenderFns } from "./RoleViewLogs.vue?vue&type=template&id=e82227d4&"
import script from "./RoleViewLogs.vue?vue&type=script&lang=js&"
export * from "./RoleViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports